// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var ReactIO = require("../../../shared/src/ReactIO.bs.js");
var WebEnvVars = require("../WebEnvVars.bs.js");
var WebTypes_View = require("../types/WebTypes_View.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var BrowserBindings_GoogleAnalytics = require("../../../shared-browser/src/bindings/BrowserBindings_GoogleAnalytics.bs.js");

var deployEnv = WebEnvVars.vars.deployEnv;

var googleAnalyticsId = "UA-107057889-1";

function WebComponents_GoogleAnalytics$AnalyticsBridge(Props) {
  var view = Props.view;
  ReactIO.useHandledIOOnMount(undefined)(BrowserBindings_GoogleAnalytics.initialize(googleAnalyticsId));
  ReactIO.useEffect1(undefined, undefined, (function (param) {
          return Relude_Globals.$great$great(WebTypes_View.toUrlParts, BrowserBindings_GoogleAnalytics.pageview, param);
        }), view);
  return null;
}

var AnalyticsBridge = {
  googleAnalyticsId: googleAnalyticsId,
  make: WebComponents_GoogleAnalytics$AnalyticsBridge
};

function WebComponents_GoogleAnalytics(Props) {
  var view = Props.view;
  if (deployEnv !== 3) {
    return null;
  } else {
    return React.createElement(WebComponents_GoogleAnalytics$AnalyticsBridge, {
                view: view
              });
  }
}

var make = WebComponents_GoogleAnalytics;

exports.deployEnv = deployEnv;
exports.AnalyticsBridge = AnalyticsBridge;
exports.make = make;
/* react Not a pure module */
